/* eslint-disable react/prop-types */
import styles from './styles.module.css'

export const PriceComparison = ({
  marketLabel = 'Esta campanha, no mercado',
  marketPrice,
  platformPrice,
  platformLabel = 'No Xamã',
  showArrow = true,
}) => {
  if (!marketPrice && !platformPrice) return null

  return (
    <div className={styles.container}>
      <div className={styles.marketSection}>
        {marketLabel && <p className={styles.marketLabel}>{marketLabel}</p>}
        {marketPrice && <p className={styles.marketPrice}>{marketPrice}</p>}
      </div>

      {showArrow && <span className={styles.arrow} aria-hidden="true">→</span>}

      <div className={styles.platformSection}>
        {platformLabel && <p className={styles.platformLabel}>{platformLabel}</p>}
        {platformPrice && <p className={styles.platformPrice}>{platformPrice}</p>}
      </div>
    </div>
  )
}

export default PriceComparison
